import React from 'react'
import getClassName from '../utilities/getClassName'
import {getIcon} from '../utilities/icon'

const Button = React.forwardRef(({onClick, classNames, disabled, children, icon, active, animate}, ref) => {

    const iconSrc = getIcon(icon)

    let className = ['button']
    if (active) {
        className = ['button button--active']
    }

    if (typeof classNames === 'object') {
        className = className.concat(classNames)
    }

    return (
        <button disabled={disabled} onClick={onClick} ref={ref} className={getClassName(className)}>
            {iconSrc.length > 0 &&
                <figure className='button__icon'>
                    {iconSrc.map((src, i) => {
                        return <img src={src} alt='' key={i} />
                    })}
                </figure>
            }
            {children}
            {animate &&
                <>
                    <div className='button__animate-1'></div>
                    <div className='button__animate-2'></div>
                </>
            }
        </button>
    )
})

export default Button